import { render } from "./PageNavigation.vue?vue&type=template&id=2148f4ee&scoped=true&ts=true"
import script from "./PageNavigation.vue?vue&type=script&lang=ts"
export * from "./PageNavigation.vue?vue&type=script&lang=ts"

import "./PageNavigation.vue?vue&type=style&index=0&id=2148f4ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2148f4ee"]])

export default __exports__